import { render, staticRenderFns } from "./relatorio-cadastro-tutor.vue?vue&type=template&id=55eec110"
import script from "./relatorio-cadastro-tutor.vue?vue&type=script&lang=js"
export * from "./relatorio-cadastro-tutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports